export const environment = {
    production: true,
    VERSION: '4.6.4',
    languages: ['en', 'fr'],
};
